export default __webpack_public_path__ + "static/media/ic_notification.5dfe6336.svg";